import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    // Create global notification function
    window.showNotification = this.show.bind(this)
  }

  show(message, type = 'info', duration = 5000) {
    const notification = this.createNotification(message, type)
    this.element.appendChild(notification)

    // Trigger animation
    setTimeout(() => {
      notification.classList.remove('translate-x-full', 'opacity-0')
    }, 10)

    // Auto dismiss
    if (duration > 0) {
      setTimeout(() => {
        this.dismiss(notification)
      }, duration)
    }

    return notification
  }

  createNotification(message, type) {
    const notification = document.createElement('div')
    notification.className = `
      transform translate-x-full opacity-0
      transition-all duration-300 ease-in-out
      max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto
      ring-1 ring-black ring-opacity-5 overflow-hidden mb-4
    `.trim().replace(/\s+/g, ' ')

    const colors = {
      success: { bg: 'bg-green-50', icon: 'text-green-400', text: 'text-green-800' },
      error: { bg: 'bg-red-50', icon: 'text-red-400', text: 'text-red-800' },
      warning: { bg: 'bg-yellow-50', icon: 'text-yellow-400', text: 'text-yellow-800' },
      info: { bg: 'bg-blue-50', icon: 'text-blue-400', text: 'text-blue-800' }
    }

    const color = colors[type] || colors.info

    const icons = {
      success: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>',
      error: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/>',
      warning: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>',
      info: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>'
    }

    notification.innerHTML = `
      <div class="p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <svg class="h-6 w-6 ${color.icon}" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              ${icons[type] || icons.info}
            </svg>
          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-sm font-medium ${color.text}">
              ${this.escapeHtml(message)}
            </p>
          </div>
          <div class="ml-4 flex-shrink-0 flex">
            <button type="button" class="inline-flex text-gray-400 hover:text-gray-500 focus:outline-none" data-action="click->notification#dismiss">
              <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    `

    return notification
  }

  dismiss(event) {
    const notification = event.target ? event.currentTarget.closest('[data-controller="notification"] > div') : event

    if (notification) {
      notification.classList.add('translate-x-full', 'opacity-0')
      setTimeout(() => {
        notification.remove()
      }, 300)
    }
  }

  escapeHtml(text) {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    }
    return text.replace(/[&<>"']/g, m => map[m])
  }
}
